import {IObservable, Observable} from 'thrive-observable-react';
import {
    createDiff,
    getUserGroupSyncHistory,
    IUserGroupSyncHistory,
    completeDiff,
    IGetUserGroupSyncHistoryResponse,
} from "../../../api/UserGroupSync";

class UserGroupSyncService {

    public userSyncHistory: IObservable<IUserGroupSyncHistory[]> = Observable<IUserGroupSyncHistory[]>([]);
    public hasMore: IObservable<boolean> = Observable<boolean>(false);

    private nextSkip: number | null = 0;


    getHistory: (skip?: number, take?: number, isPagination?: boolean) => Promise<void> = async (skip = 0, take = 20, isPagination: boolean = false) => {
        const res = await getUserGroupSyncHistory(skip, take) as IGetUserGroupSyncHistoryResponse;

        if(res .items) {
            const history = isPagination
                ? [...this.userSyncHistory.value, ...res.items]
                : res.items;
            this.userSyncHistory.update(history);
            this.nextSkip = res.nextSkip;
            this.hasMore.update(res.nextSkip > 0);
        }
    }

    getNextPage = async () => {
        await this.getHistory(
            this.nextSkip ? this.nextSkip : 0,
            20,
            true
        )
    };

    refreshHistory = async (hasNewItem?: boolean) => {
        const refreshCount = hasNewItem
            ? this.userSyncHistory.value.length + 1
            : this.userSyncHistory.value.length
        await this.getHistory(0, refreshCount)
    }

    createDiff = (file: File) => {
        if (!file) {
            throw new Error("A file is required to create a diff.");
        }

       return createDiff(file);
    }

    /**
     * Complete (execute) a previously created sync/diff.
     * @param {string|number} syncId
     */
    async completeSync(syncId: string) {
        const response = await completeDiff(syncId);

        if (!response.ok) {
            console.error("Unable to complete sync.");
        }

        return true;
    }

    /**
     * Which sync statuses should show a "Complete" action.
     */
    static get completableStatuses() {
        return ["DiffCreated"];
    }

    /**
     * Which sync statuses should show a "Diff" link.
     */
    static get diffViewableStatuses() {
        return ["DiffCreated", "Executing", "Completed", "Failed"];
    }

    canComplete(status: any) {
        return UserGroupSyncService.completableStatuses.includes(status);
    }

    canViewDiff(status: any) {
        return UserGroupSyncService.diffViewableStatuses.includes(status);
    }


    summarizeDiffResult(result :any) {
        const includedDiffs = result.diffs.filter((d: any) => d.userSyncExcluded === false);
        const excludedDiffs = result.diffs.filter((d: any) => d.userSyncExcluded === true);

        const groupsBeingAdded: number = includedDiffs.reduce(
            (accumulator: number, currentValue: any) => accumulator + currentValue.groupsBeingAdded.length,
            0,
        )

        const groupsBeingRemoved: number = includedDiffs.reduce(
            (accumulator: number, currentValue: any) => accumulator + currentValue.groupsBeingRemoved.length,
            0,
        )

        return {
            usersProcessed: result.diffs.length,
            groupsCreated: result.groupsBeingCreated.length,
            userGroupsAdded: groupsBeingAdded,
            userGroupsRemoved: groupsBeingRemoved,
            usersExcluded: excludedDiffs.length,
            groupsExcluded: result.groupsExcluded.length
        };
    }
}

export { UserGroupSyncService };